import ScrollProgress from "@/components/ScrollProgress";

/** Global scroll progress indicator (all marketing routes). */
export default function ScrollProgressGate() {
  return <ScrollProgress />;
}
